import React, {useState, useEffect} from 'react';
import AuthContext from './AuthContext';
import Request from "../../../bootstrap/api/Request";
import routes from "../../routing/routes";
import {ROLE_ADMIN} from "../../model-constants/user/roles";
import AccountInfoParcel from '../../api/endpoints/account/AccountInfoParcel';
import SplashScreen from '../../screens/splash/SplashScreen';
import AuthLogoutParcel from '../../api/endpoints/auth/AuthLogoutParcel';
import Toasts, {TOAST_ERROR} from '../../../bootstrap/scomponents/toasts/Toasts';


export default function AuthContextWrapper({children}) {

    const [info, setInfo] = useState({});
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        Request.add(new AccountInfoParcel())
            .then(info => {
                setInfo(info);
                setIsReady(true);
            })
            .catch(error => {
                setIsReady(true);
            });
    }, []);

    const {user = null, avatarImage = null} = info;

    const canAccess = (path) => {
        switch (path) {
            case routes.dashboard.path:
            case routes.user_management.path:
            case routes.image_management.path:
            case routes.audio_management.path:
            case routes.video_management.path:
            case routes.document_management.path:
            case routes.banner_management.path:
            case routes.course_management.path:
            case routes.chapter_management.path:
            case routes.lesson_management.path:
            case routes.enrollment_management.path:
                return user !== null && user.role === ROLE_ADMIN;
            case routes.checkout.path:
            case routes.library.path:
            case routes.learning.path:
            case routes.user_profile.path:
                return user !== null;
            default:
                return true;
        }
    };

    const patchInfo = (values) => {
        setInfo({...info, ...values});
    };

    const logout = () => {
        Request.add(new AuthLogoutParcel())
            .then(() => {
                setInfo({});
            })
            .catch(error => {
                Toasts.add(TOAST_ERROR, error.getMessage());
            });
    }

    const contextValue = {
        user,
        avatarImage,
        setInfo,
        patchInfo,
        logout,
        canAccess
    };

    if (!isReady) {
        return <SplashScreen/>;
    }

    return <AuthContext.Provider value={contextValue}>
        {children}
    </AuthContext.Provider>;
}
